import Router from "next/router";

import { CardButton } from "@/components/Card/CardButton";
import { LinkUtils } from "@/utils/linkUtils";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import { Card, CardContent, CardMedia, Divider, Stack, Typography } from "@mui/material";

import { styles } from "./styles";
import { DefaultRedeemPartnerCardProps } from "./types";

export const DefaultRedeemPartnerCard: React.FC<DefaultRedeemPartnerCardProps> = ({ card, parentPartnerName }) => {
  if (!card) {
    return null;
  }

  const urlInformativeCard = `/categoria/${card.category.id}/parceiro/${card.partner.id}/informativo`;

  return (
    <Card
      onClick={() => {
        if (card.redemptionUrl) {
          return window.open(card.redemptionUrl, "_blank");
        }

        if (card.isInformative) {
          if (card.url || card.buttonUrl) {
            LinkUtils.openLink(card.url || card.buttonUrl);
          } else {
            Router.push(urlInformativeCard);
          }
        } else {
          LinkUtils.openProduct({
            categoryId: card.category.id,
            partnerId: card.partner.id,
            productIdOrExternalCode: card.productId
          });
        }
      }}
      sx={{
        flexDirection: "column",
        minHeight: "170px",
        cursor: "pointer",
        borderRadius: "16px",
        height: "100%",
        maxWidth: { xs: "100%", sm: "282px" },
        display: "flex"
      }}
    >
      <CardMedia
        component="img"
        src={card.image || "/placeholder.png"}
        alt="Imagem do card"
        width="100%"
        height="208.28px"
        sx={{ px: card.isInformative ? 2 : 0 }}
        style={{ alignSelf: "start", objectFit: card.isInformative ? "contain" : "cover", flex: "1 0 auto", maxHeight: "208.28px" }}
      />

      <CardContent sx={{ display: "flex", flexDirection: "column", px: "16px !important", pt: "20px", pb: "31px !important", flex: 1 }}>
        <Typography css={card.isInformative ? styles.partnercard__title : styles.partner}>{card.partner?.name}</Typography>

        <Stack flex={1}>
          <Typography component="div" css={card.isInformative ? styles.informative_description : styles.description}>
            {typeof card.title === "object" ? documentToReactComponents(card.title as Document) : card.title}
          </Typography>
        </Stack>

        <Stack justifyContent="space-between">
          {card.points ? <Typography css={styles.points}>{card.points} pontos KMV</Typography> : null}

          <Divider
            sx={{
              borderColor: "#0000001F",
              my: "16px"
            }}
          />

          {card.expiration ? (
            <Typography css={styles.validity}>
              <Typography css={styles.validity_title} component="span">
                {"Validade: "}
              </Typography>

              {card.expiration}
            </Typography>
          ) : null}

          {card.isInformative ? (
            <CardButton
              buttonType="INFORMATIVO"
              title={card.buttonTitle}
              buttonUrl={urlInformativeCard}
              cardTitle={card.title as string}
              partnerName={card.partner?.name}
              dispatchGtagEvent={true}
              parentPartnerName={parentPartnerName}
            />
          ) : (
            <CardButton
              buttonType="RESGATE"
              categoryId={card.category.id}
              partnerId={card.partner.id}
              productId={card.productId}
              cardTitle={card.title as string}
              partnerName={card.partner?.name}
              dispatchGtagEvent={true}
              parentPartnerName={parentPartnerName}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
